import React, { memo } from 'react';
import { convertSecondsToTimeString } from '@/Pages/Clip/SideBar/ClipDuration/utils';
import { useRemotionPlayerCurrentTime } from '@/App/remotion/MainPlayer/ClipPlayerV2WithNewTimeline/hooks/useRemotionPlayerCurrentTime';
import useRemotionPlayerDuration from '@/App/remotion/MainPlayer/ClipPlayerV2WithNewTimeline/hooks/useRemotionPlayerDuration';

function PlayerTime() {
  const { currentTime } = useRemotionPlayerCurrentTime();
  const fullDuration = useRemotionPlayerDuration();
  const currentTimeInSeconds = currentTime;
  const totalTimeWithFormat = convertSecondsToTimeString(fullDuration || 0, 'HH:mm:ss');
  const currentTimeWithFormat = convertSecondsToTimeString(currentTimeInSeconds || 0, 'HH:mm:ss');
  return (
    <div className="flex items-center gap-2">
      <div>{currentTimeWithFormat}</div>/<div>{totalTimeWithFormat}</div>
    </div>
  );
}
export default memo(PlayerTime);
